import { render, staticRenderFns } from "./MedicinesPicker.vue?vue&type=template&id=3ecfa013&"
import script from "./MedicinesPicker.vue?vue&type=script&lang=js&"
export * from "./MedicinesPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VCombobox,VListItemContent})
